import AxiosConfig from '@/config/axios-config'

export const LiveAPI = {

  listarLives () {
    return AxiosConfig.secureJalekoAPI().get('/live').then(response => response.data)
  }

}

export default LiveAPI
